import { WorkPackagesSheetPageContent } from '@/app/components/features/workPackages/WorkPackagesSheetPageContent';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authed/project/$projectId/_layout/(evaluation)/contracts/$contractId/_layout/(main)/work-packages/$sheetId/_layout/',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { contractId } = Route.useParams();

  return <WorkPackagesSheetPageContent evaluationId={contractId} type="Contract" />;
}
